import { useTranslation } from "react-i18next";

import { IconUsers01 } from "@pentabd/icons";
import { Avatar, Header } from "@pentabd/ui";

import { useGeneralInfo } from "@hooks/HRM/employee/useGeneralInfo";

import { ROUTES } from "@constants/routes";
import { GetEmployeeDetails } from "@utils/getEmployeeDetails";

const {
  INVENTORY: { EMPLOYEES },
} = ROUTES;

export const EmployeePageHeader = ({ id }: any) => {
  const translation = useTranslation();
  const { t } = translation;

  const { generalInfo } = useGeneralInfo(id);
  const { employeeName, employeePosition, employeeImage } = GetEmployeeDetails(
    generalInfo as any,
  );

  if (generalInfo) {
    const breadcrumbs = [
      {
        icon: <IconUsers01 fill="dark" size="20" />,
      },
      {
        label: t("EMPLOYEE.BREADCRUMBS.FIRST_STEP"),
        link: EMPLOYEES,
      },
      {
        label: employeeName,
      },
    ];

    return (
      <Header
        breadcrumbs={breadcrumbs}
        headerText={{
          header: employeeName,
          subHeader: employeePosition,
        }}
        avatar={<Avatar name={employeeName} imageURL={employeeImage} />}
      />
    );
  } else return <></>;
};
